import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {HmainOp, Hsub, Province, ZoneDto} from "../../../../generated-model/model";
import {environment} from "../../../../environments/environment";
import {IgnoreNullHttpParams} from "../Ignore-null-http-params";

@Injectable({
  providedIn: 'root'
})
export class HsubResource {
  http = inject(HttpClient)

  constructor() {
  }

  public search(term: string, zone?: ZoneDto, province?: Province, hmainOp?: HmainOp): Observable<Hsub[]> {
    return this.http.get<Hsub[]>(`${environment.serverUrl}/api/hsub`, {
      params: IgnoreNullHttpParams.fromObject({
        term: term,
        zoneId: zone?.id,
        provinceId: province?.id,
        hmainOp: hmainOp?.hcode
      }).toHttpParam()
    });
  }
}
